export default class Base {}
